<div class="p-l">
  <span class="subheader">Ändern Sie Ihre persönlichen Angaben</span>
  <p>Hier haben Sie die Möglichkeit Änderungen Ihrer persönlichen Daten zu beantragen.</p>
  <form [formGroup]="personalForm">
    <mat-form-field appearance="outline">
      <mat-label>Anrede</mat-label>
      <mat-select formControlName="salutation">
        @for (salutation of getSalutationValues(); track salutation) {
          <mat-option [value]="salutation">
            {{salutation}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Titel</mat-label>
      <input matInput formControlName="title">
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Vorname</mat-label>
      <input matInput formControlName="first_name">
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Name</mat-label>
      <input matInput formControlName="last_name"/>
    </mat-form-field>
    <button mat-flat-button color="primary" (click)="updateUserData()" class="mr-m">Änderungen beantragen</button>
    <button mat-button (click)="closeDialog()">Abbrechen</button>
  </form>
</div>


